import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import './index.scss';
import { ReactComponent as KeyboardIcon } from '../../assets/images/bar-code-icon.svg';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import { ReactComponent as Voucher } from '../../assets/images/voucher.svg';
import { keyboardLayout } from '../../utils/keyBoardLayout';
import spinnerLoader from '../../assets/images/spinner-loader.gif';
import { ReactComponent as CardSwipe } from "../../assets/images/card-swipe.svg"
import { ReactComponent as TryAgain } from "../../assets/images/try-again.svg";

const buttonTheme = [
  {
    class: 'phone-login-close-button',
    buttons: '{phoneLoginCloseButton}',
  },
  {
    class: 'backspace-button',
    buttons: '{bksp}',
  },
];

export default class GiftCardModal extends Component {
  render() {
    return (
      <>
        <Modal show={this.props.parentState.giftCardModalSH} dialogClassName="gift-card-popup" centered>
          <Modal.Body>
            <div
              className={`close-btn ${this.props.parentState.giftcardClickhereDisabled ? '' : 'disabled'}`}
              onClick={() => this.props.scanModalCloseBtnClick(this.props.parentState.giftcardScanningSecSH ? 'manualEntry' : 'giftCardSwipe')}
            >
              <a href="javascript:;" title="Close">
                &nbsp;
              </a>
            </div>
            <div className="content">
              {this.props.parentState.giftcardScanningSecSH ? (
                <>
                  {window.constant.GIFT_GARD_MANUAL_ENTRY_ALLOWED === true && (
                    <>
                      <h2>Gift Card</h2>
                      <p>Enter your gift card number or swipe your card</p>
                      <div className="form-blk">
                        <div className={`input-wrap ${window.constant.GIFT_GARD_SCANNING_ALLOWED ? '' : 'no-border'}`}>
                          <input
                            ref={input => {
                              this.textInput = input;
                            }}
                            id="voucherInput"
                            type="text"
                            placeholder="ENTER YOUR GIFT CARD NUMBER"
                            autoComplete="off"
                            value={this.props.parentState.giftCardNumber}
                            readOnly
                          />
                        </div>
                      </div>
                      {window.constant.GIFT_GARD_SCANNING_ALLOWED && (
                        <>
                          <div className="separator">
                            OR
                          </div>
                          <button onClick={this.props.giftCardKeyboardIcon} className={`btn btnPrimary gc-scan-btn`} title="SWIPE YOUR GIFT CARD">
                            <span>
                              <p>SWIPE YOUR GIFT CARD</p>
                              <p>Tap to swipe through the card reader</p>
                            </span>
                            <CardSwipe />
                          </button>
                        </>
                      )}
                      {this.props.parentState.giftcardErrorMsg != '' && (
                        <div className="error-blk">
                          <p>{this.props.parentState.giftcardErrorMsg}</p>
                        </div>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  {
                    window.constant.USE_CALL_ENABLE_BARCODE_SCAN_FOR_GC ?
                      <Voucher /> :
                      <img src={"/assets/images/swipe.png"} alt="Scan" className='card-swipe-img' />
                  }
                  <h1 className='scan-title'>
                    {
                      window.constant.USE_CALL_ENABLE_BARCODE_SCAN_FOR_GC ?
                        "Scan your Gift Card" :
                        "Swipe your gift card through  the card reader and follow the instructions to complete your transaction."
                    }
                  </h1>
                  <div className="loader-blk">
                    {!this.props.parentState.giftcardClickhereDisabled && (
                      <div>
                        <img src={spinnerLoader} alt="Loader" />
                        <p>{this.props.parentState.giftcardScanningLoaderMsg}</p>
                      </div>
                    )}
                    {/* <p className={`clickhere ${this.props.parentState.giftcardClickhereDisabled ? '':'disabled'}`}><a onClick={this.props.enterManuallyClick} href="javascript:;">Click here</a> to enter your Gift card number manually.</p> */}
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
          {this.props.parentState.giftcardScanningSecSH &&
            <Modal.Footer>
              <div className="scan-btn">
                <a onClick={this.props.redeemBtnClick} href="javascript:;" className={`btn btnPrimary ${this.props.disableRedeemBtn() ? 'disabled' : ''}`} title="REDEEM">
                  REDEEM
                </a>
              </div>
            </Modal.Footer>
          }
        </Modal>
        {this.props.parentState.giftCardKeyboardSH ? (
          <Keyboard
            keyboardRef={r => (this.keyboard = r)}
            layoutName={this.props.parentState.keyBoardLayoutName}
            onChange={this.props.giftCardKeyBoardOnChange}
            onKeyPress={this.props.giftCardKeyBoardOnKeyPress}
            layout={keyboardLayout}
            display={{
              '{bksp}': 'Backspace',
              '{phoneLoginCloseButton}': 'Close',
            }}
            disableRowButtonContainers={true}
            baseClass={'giftcard-keyboard'}
            buttonTheme={buttonTheme}
          />
        ) : null}

        <Modal show={this.props.parentState.giftcardShowErrorModal} dialogClassName="gift-card-popup gift-card-error-popup" centered>
          <Modal.Body>
            <div
              className={`close-btn ${this.props.parentState.giftcardClickhereDisabled ? '' : 'disabled'}`}
              onClick={() => this.props.closeGcScanErrorModal()}
            >
              <a href="javascript:;" title="Close">
                &nbsp;
              </a>
            </div>
            <div className="content">
              <img src={"/assets/images/swipe-error.png"} alt="" className='swipe-error-icon' />
              <h2>{this.props.parentState.giftcardResponse?.code === '500' && (this.props.parentState.giftcardResponse?.message.toLowerCase().includes('cancel') || this.props.parentState.giftcardResponse?.message.toLowerCase().includes('failure')) ? 'Unable to read your Gift Card' : this.props.parentState.giftcardResponse?.message} </h2>
              <p>Please swipe your card in the card reader and try again.</p>
              <btn
                onClick={() => { this.props.giftCardKeyboardIcon() }}
                className={`btn btnPrimary retry-swipe-btn`}
                title="Retry"
              >
                <TryAgain /> Retry
              </btn>
              <div className="separator">
                OR
              </div>
              <btn
                onClick={() => { this.props.closeGcScanErrorModal(); this.props.giftCardOnClick(); }}
                className={`btn btnPrimary enter-gc-manual-btn`}
                title=" Enter Manually"
              >
                Enter Manually
              </btn>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
